"use client";

import { useState } from "react";
import { X } from "lucide-react";
import { Vehicle } from "@/types/vehicle.types";

interface SelectedVehiclesOverlayProps {
  selectedVehicles: Vehicle[];
  onRemoveVehicle: (id: number) => void;
  onClose: () => void;
}

export function SelectedVehiclesOverlay({
  selectedVehicles,
  onRemoveVehicle,
  onClose,
}: SelectedVehiclesOverlayProps) {
  const [filterText, setFilterText] = useState("");

  const filtered = selectedVehicles.filter((v) =>
    [
      v.make,
      v.model,
      v.modelYear,
      v.fuelType,
      v.transmission,
    ].some((field) => field.toLowerCase().includes(filterText.toLowerCase()))
  );

  return (
    <div className="vehicle-overlay">
      <div className="vehicle-model-panel">
        
        {/* HEADER */}
        <div className="vehicle-model-header">
          <h3 className="vehicle-model-title">Selected Vehicles</h3>
          <button
            className="close-btn vehicle-model-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        {/* SEARCH BAR */}
        <input
          placeholder="Search selected vehicles..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          className="vehicle-input model-search-input"
        />

        {/* VEHICLE LIST */}
        <div className="vehicle-list">
          {filtered.length > 0 ? (
            filtered.map((v) => (
              <div key={v.id} className="selected-vehicle-list-item">

                <div className="vehicle-details">
                  <strong>
                    {v.make} {v.model} ({v.modelYear})
                  </strong>
                  <p style={{ marginLeft: "1em" }}>• Fuel: {v.fuelType}</p>
                  <p style={{ marginLeft: "1em" }}>• Transmission: {v.transmission}</p>
                  <p style={{ marginLeft: "1em" }}>• Cylinders: {v.cylinders}</p>
                  <p style={{ marginLeft: "1em" }}>• Engine Size: {v.engineSize_L}L</p>
                </div>

                <button
                  className="close-btn remove-selected-vehicle-btn"
                  aria-label="Remove Vehicle"
                  onClick={() => onRemoveVehicle(v.id)}
                >
                  <X size={18} className="lucide-icon" />
                </button>
              </div>
            ))
          ) : (
            <p>No matching vehicles.</p>
          )}
        </div>

      </div>
    </div>
  );
}
